import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { Button } from 'foundations-components/transitional/components/Button';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACBadRequestError = ({
  'data-test-id': dataTestId = 'bad-request-error',
  href,
  to
}) => /*#__PURE__*/_jsxs(ErrorMessage, {
  "data-test-id": dataTestId,
  type: "badRequest",
  children: [/*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.badRequest.somethingsGoneWrong"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.badRequest.refreshPage"
    })]
  }), (to || href) && /*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.filters.common.subtitle"
    }), /*#__PURE__*/_jsx("br", {}), to ? /*#__PURE__*/_jsx(RouterLink, {
      to: to,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.errors.filters.common.clearFilters"
      })
    }) : /*#__PURE__*/_jsx(Button, {
      href: href,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.errors.filters.common.clearFilters"
      })
    })]
  }), /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.badRequest.keepsHappening"
    })
  })]
});
export default ACBadRequestError;